// названия страниц для логики АБ тестов в приложении на клиенте (должны проставляться в контроллере страницы на сервере)
export const APP_PAGES_NAMES = {
  LOANS_RATES: 'loansRates',
  LOANS_OFFERS: 'loansOffers',
  NEW_FORM: 'newForm',
  NEW_FORM_WL: 'newFormWL',
  LOANS_OFFERS_RESTORE: 'loansOffersRestore',
  WAYBACK_RESTORE: 'waybackRestore',
  NEW_FORM_RESTORE: 'newFormRestore',
  CREDIT_FULL_DEAL: 'creditFullDeal',
  PRODUCT: 'product',
  PRODUCT_FORM: 'productForm',
  PRODUCT_STATUS: 'productStatus',
  VITRINS: 'vitrins',
  OBRAZOVANIE: 'kredit_na-obrazovanie',
  IPHONEE: 'kredit_na-iphonee',
  NALICHNYMI: 'kredit-nalichnymi',
  BEZ_POSESHHENIJA_BANKA: 'kredit_na-kartu-bez-poseshhenija-banka',
  MARKETPLACE_SEO_LANDING: 'marketplaceSeoLanding',
  LOANS_SEO_LANDING: 'loansSeoLanding',
  CREDIT_CARDS_SEO_LANDING: 'creditCardsSeoLanding',
  COMPLETED_DEAL: 'creditCompletedDeal',
  // в случае возвращения undefinedPage проверить контроллер server/controllers/pages/[страница].ts
  UNDEFINED_PAGE: 'undefinedPage',
} as const;
